<div class="card">
  <div class="card-header">
    <div class="card-title">
      Set User Password
    </div>
  </div>

  <div class="card-body">
    <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
      <input class="form-control flex-grow-1" [(ngModel)]="userEmail" placeholder="User's Email Address" required data-testid="set-user-password-user-email">
      <input class="form-control flex-grow-1" [(ngModel)]="newPassword"placeholder="New Password" required data-testid="set-user-password-new-password">
    </div>

    <button
      type="submit"
      class="btn btn-primary btn-sm"
      aria-label="Save New Password"
      [disabled]="!userEmail || !newPassword || isSaving"
      (click)="save()"
      data-testid="set-user-password-save-new-password">
      <span *ngIf="!isSaving">Save New Password</span>

      <span *ngIf="isSaving">
        <i class="fa fa-spinner fa-spin fa-fw mr-1"></i>
        Saving...
      </span>
    </button>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/set-user-password/set-user-password.component.html